import { defineComponent, openBlock, createElementBlock, normalizeStyle, createElementVNode, createCommentVNode } from 'vue';
import _export_sfc from '../_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "FillBookOpen",
  props: {
    gradient: {
      type: Boolean
    },
    opacity: {
      type: [Number, String],
      default: "0.35"
    },
    startColor: {
      type: String,
      default: ""
    },
    iconId: [String, Number]
  }
});
const _hoisted_1 = { key: 0 };
const _hoisted_2 = ["id"];
const _hoisted_3 = /* @__PURE__ */ createElementVNode("stop", {
  "stop-color": "currentColor",
  offset: "100%"
}, null, -1);
const _hoisted_4 = ["fill"];
const _hoisted_5 = /* @__PURE__ */ createElementVNode("path", { d: "M8,3 C9.63618194,3 11.0888064,3.78590304 12.0009752,5.00081101 L12.0006545,23.0014185 C11.6512449,23.0056479 11.2982781,22.8334822 11.105176,22.4464192 L11.105176,22.4464192 L11.0169316,22.2841126 C10.5494938,21.4922661 9.69574312,21 8.76714245,21 L8.76714245,21 L4,21 C2.8954305,21 2,20.1045695 2,19 L2,19 L2,5 C2,3.8954305 2.8954305,3 4,3 L4,3 Z" }, null, -1);
const _hoisted_6 = /* @__PURE__ */ createElementVNode("path", {
  d: "M20,3 C21.1045695,3 22,3.8954305 22,5 L22,5 L22,19 C22,20.1045695 21.1045695,21 20,21 L20,21 L15.2397989,21 C14.301848,21 13.4360766,21.50071 12.9825705,22.2846515 L12.9825705,22.2846515 L12.880299,22.4744192 C12.6818834,22.8425854 12.338411,23.005755 11.9988621,23.0015171 L11.99827,5.00181655 C12.9103922,3.7863367 14.3633667,3 16,3 L16,3 Z",
  style: { "opacity": "var(--fill-opacity)" }
}, null, -1);
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    "aria-labelledby": "BookOpen",
    role: "presentation",
    class: "icon-fill",
    style: normalizeStyle({
      "--fill-opacity": _ctx.opacity
    }),
    fill: "currentColor"
  }, [
    _ctx.gradient ? (openBlock(), createElementBlock("defs", _hoisted_1, [
      createElementVNode("linearGradient", {
        id: _ctx.iconId,
        x1: "50%",
        y1: "0%",
        x2: "50%",
        y2: "100%",
        gradientUnits: "userSpaceOnUse"
      }, [
        createElementVNode("stop", {
          style: normalizeStyle({
            stopColor: _ctx.startColor ? _ctx.startColor : "var(--icon-start-color)"
          }),
          offset: "0%"
        }, null, 4),
        _hoisted_3
      ], 8, _hoisted_2)
    ])) : createCommentVNode("v-if", true),
    createElementVNode("g", {
      stroke: "none",
      "stroke-width": "1",
      fill: _ctx.gradient ? "url(#" + _ctx.iconId + ")" : "currentColor",
      "fill-rule": "evenodd"
    }, _hoisted_7, 8, _hoisted_4)
  ], 4);
}
var BookOpen = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);

export { BookOpen as default };
